import { BrowserRouter, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./hooks/auth/useAuthWrapper";
import "bootstrap/dist/css/bootstrap.css";
import "./scss/index.scss";
import "./App.css";
import Services from "./pages/diensten";
import Service from "./pages/dienst";

import Index from "./pages";
import DashboardLayout from "./admin/dashboard-layout";
import SupportManager from "./admin/SupportManager";
import UploadsManager from "./admin/UploadManager";
import { Settings } from "lucide-react";
import NotFound from "./pages/NotFound";
import Login from "./pages/login";
import Dashboard from "./pages/admin";
import References from "./pages/realisaties";
import Reference from "./pages/realisatie";
import About from "./pages/overons";
import Contact from "./pages/contact";
import PolicyPage from "./pages/privacybeleid";
import ConditionsPage from "./pages/algemene-voorwaarden";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/diensten" element={<Services />} />
        <Route path="/diensten/:url" element={<Service />} />
        <Route path="/realisaties" element={<References />} />

        <Route path="realisaties/:url" element={<Reference />} />

        <Route path="/overons" element={<About />} />

        <Route path="/contact" element={<Contact />} />
        <Route path="/privacypolicy" element={<PolicyPage />} />
        <Route path="/algemene-voorwaarden" element={<ConditionsPage />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/dashboard/*"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="support" element={<SupportManager />} />
          <Route path="gallery" element={<UploadsManager />} />
          <Route path="settings" element={<Settings />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
